export class DateFormatHelper {
  static getAllDateFormats(): string[] {
    const days = ["d", "dd"];
    const months = ["M", "MM", "MMM"];
    const years = ["yy", "yyyy"];
    const separators = ["/", "-", ".", " ", "", ","];

    const formats = new Set<string>();

    for (const d of days) {
      for (const m of months) {
        for (const y of years) {
          for (const sep of separators) {
            // Day-Month-Year
            formats.add(`${d}${sep}${m}${sep}${y}`);

            // Month-Day-Year
            formats.add(`${m}${sep}${d}${sep}${y}`);

            // Year-Month-Day
            formats.add(`${y}${sep}${m}${sep}${d}`);
          }
        }
      }
    }

    // Add weekday prefix (EEE)
    const withWeekday: string[] = [];
    for (const f of formats) {
      withWeekday.push(`EEE, ${f}`);
    }

    withWeekday.forEach((f) => formats.add(f));

    return Array.from(formats);
  }

  static getAllDateFormatsWithDefault(
    asObject: boolean = false
  ): { value: string; isDefault: boolean }[] {
    const days = ["d", "dd"];
    const months = ["M", "MM", "MMM"];
    const years = ["yy", "yyyy"];
    const separators = ["/", "-", ".", " ", "", ","];

    const formats = new Set<string>();

    for (const d of days) {
      for (const m of months) {
        for (const y of years) {
          for (const sep of separators) {
            // Day-Month-Year
            formats.add(`${d}${sep}${m}${sep}${y}`);

            // Month-Day-Year
            formats.add(`${m}${sep}${d}${sep}${y}`);

            // Year-Month-Day
            formats.add(`${y}${sep}${m}${sep}${d}`);
          }
        }
      }
    }

    // Add weekday prefix (EEE)
    const withWeekday: string[] = [];
    for (const f of formats) {
      withWeekday.push(`EEE, ${f}`);
    }

    withWeekday.forEach((f) => formats.add(f));
    const result = Array.from(formats);
    return result.map((f) => ({ value: f, isDefault: true }));
  }
}
